// Category definitions: each type declares its subtypes, which base fields it
// uses (marca/modelo siempre), and its extra specs (rendered from `form.specs`).
export const EQUIPMENT_TYPES = [
  {
    key: "laptop", label: "Laptop", subtypes: null,
    baseFields: ["processor", "ram", "storage"],
    extras: [],
    charger: true, battery: true,
    hasGpuGroup: true,
  },
  {
    key: "cpu", label: "CPU / PC de escritorio",
    subtypes: [
      { key: "torre", label: "Torre" },
      { key: "mini", label: "Mini PC" },
      { key: "sff", label: "SFF" },
      { key: "servidor", label: "Servidor" },
    ],
    baseFields: ["processor", "ram", "storage"],
    extras: [
      { key: "power_supply", label: "Fuente de poder", placeholder: "ej. 650W 80+ Bronze" },
      { key: "mobo", label: "Motherboard", placeholder: "ej. B550 Aorus Elite" },
    ],
    charger: false, battery: false,
    hasGpuGroup: true,
  },
  {
    key: "phone", label: "Celular", subtypes: null,
    baseFields: ["storage"],
    extras: [
      { key: "imei", label: "IMEI", placeholder: "15 dígitos" },
      { key: "color", label: "Color", placeholder: "ej. Titanio Negro" },
      { key: "battery_health", label: "Salud de batería (%)", placeholder: "ej. 85" },
      { key: "network_lock", label: "Estado de red", placeholder: "libre / bloqueado / iCloud" },
    ],
    charger: true, battery: false,
  },
  {
    key: "tablet", label: "Tableta", subtypes: null,
    baseFields: ["storage"],
    extras: [
      { key: "color", label: "Color", placeholder: "ej. Space Gray" },
      { key: "screen_size", label: "Tamaño de pantalla", placeholder: "ej. 10.9\"" },
      { key: "battery_health", label: "Salud de batería (%)", placeholder: "ej. 90" },
      { key: "cellular", label: "Conectividad", placeholder: "Wi-Fi / Wi-Fi + Celular" },
    ],
    charger: true, battery: false,
  },
  {
    key: "monitor", label: "Monitor", subtypes: null,
    baseFields: [],
    extras: [
      { key: "screen_size", label: "Tamaño (pulgadas)", placeholder: "ej. 27\"" },
      { key: "resolution", label: "Resolución", placeholder: "ej. 2560x1440" },
      { key: "panel", label: "Panel", placeholder: "IPS / VA / OLED / TN" },
      { key: "refresh_rate", label: "Refresco (Hz)", placeholder: "ej. 144" },
      { key: "ports", label: "Puertos", placeholder: "HDMI x2, DP x1, USB-C" },
    ],
    charger: false, battery: false, cable: true,
  },
  {
    key: "gadget", label: "Gadget / accesorio",
    subtypes: [
      { key: "camara", label: "Cámara" },
      { key: "gopro", label: "GoPro / acción" },
      { key: "audifonos", label: "Audífonos" },
      { key: "webcam", label: "Webcam" },
      { key: "drone", label: "Drone" },
      { key: "otro", label: "Otro" },
    ],
    baseFields: [],
    extras: [
      { key: "gadget_description", label: "Descripción libre", placeholder: "Tipo, características, accesorios", multiline: true },
    ],
    charger: false, battery: false,
  },
];

export const TYPE_MAP = Object.fromEntries(EQUIPMENT_TYPES.map((t) => [t.key, t]));
